import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"
import _imports_0 from '../../../../assets/static/decola_logos/logo04_sem_slogan.svg'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  width: "150",
  class: "menu__logo",
  alt: "Logo do Decola."
}, null, -1)
const _hoisted_2 = { class: "menu__list" }
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = ["href", "target"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("nav", {
      class: _normalizeClass([
      'menu',
      { expand: _ctx.isOpen },
      { collapse: !_ctx.isOpen && _ctx.userAlreadyToggle },
    ])
    }, [
      _hoisted_1,
      _createElementVNode("ul", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
          return (_openBlock(), _createElementBlock("li", {
            class: "menu__item",
            key: index
          }, [
            _createElementVNode("img", {
              width: "25",
              height: "25",
              src: require(`../../../../assets/static/main-menu/${item.image}`),
              alt: `Ícone de ${item.title}`
            }, null, 8, _hoisted_3),
            (item.route.target)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  href: item.route.path,
                  target: item.route.target,
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('toggle-menu')))
                }, _toDisplayString(item.title), 9, _hoisted_4))
              : (_openBlock(), _createBlock(_component_router_link, {
                  key: 1,
                  to: { name: item.route.name, params: item.route.params },
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('toggle-menu')))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.title), 1)
                  ]),
                  _: 2
                }, 1032, ["to"]))
          ]))
        }), 128))
      ])
    ], 2),
    (_ctx.isOpen)
      ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.$emit('toggle-menu')), ["prevent"])),
          class: "menu__trigger-area"
        }))
      : _createCommentVNode("", true)
  ], 64))
}